export const statusColors = {
  revise: {
    submit: '#AED6F1',
    prequalification: '#5DADE2',
    specialization: '#3498D8',
    finance: '#2E86C1',
    approved: '#2874A6',
    notQualified: '#E74C3C',
  },

  submit: {
    ongoingProject: '#2874A6',
    midtermQualifiedProject: '#239B56',
    midtermNotQualifiedProject: '#CB4335',
    acceptanceQualifiedProject: '#1D8348',
    acceptanceNotQualifiedProject: '#943126',
    overdueProject: '#FFA64D',
  },

  reviseViewList: {
    new: '#3796d4',
    submit: '#318fcc',
    prequalification: '#2980B9',
    specialization: '#3498D8',
    finance: '#2E86C1',
    approved: '#22C55E',
    notQualified: '#E74C3C',
  },
};

export const formatShowAppliedFilters = (appliedFilters, organizations, programs, t) => {
  let text = '';
  if (Array.isArray(appliedFilters.yearProposed) && appliedFilters.yearProposed.length > 0) {
    text += `${t(
      'dashboard.projectRevise.dropdown.yearProposed'
    )}: ${appliedFilters.yearProposed.join(', ')}; `;
  }
  if (Array.isArray(appliedFilters.organizationId) && appliedFilters.organizationId.length > 0) {
    text += `${t('dashboard.projectRevise.dropdown.organization')}: ${appliedFilters.organizationId
      .map((id) => organizations.find((org) => org.id === id)?.name)
      .join(', ')}; `;
  }
  if (Array.isArray(appliedFilters.programId) && appliedFilters.programId.length > 0) {
    text += `${t('dashboard.projectRevise.dropdown.program')}: ${appliedFilters.programId
      .map((id) => programs.find((prog) => prog.id === id)?.name)
      .join(', ')};`;
  }
  text = text.trim().replace(/;$/, '');
  return <div className="text-wrap">{text}</div>;
};
